<template>
  <div>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <b-form @submit.prevent="handleSubmit(onSubmit)">
        <b-row>
          <!-- Field: Name -->
          <b-col cols="12">
            <validation-provider 
              #default="validationContext" 
              name="Name"
              rules="required"
            >
              <b-form-group>
                <h5>{{ $t('plant.name') }}</h5>
                <b-form-input
                  id="name" 
                  v-model="localPlantData.name"
                  :state="getValidationState(validationContext)"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- Field: Address -->
          <b-col cols="12">
            <validation-provider 
              #default="validationContext" 
              name="Address"
              rules="required"
            >
              <b-form-group>
                <h5>{{ $t('plant.address') }}</h5>
                <b-form-textarea
                  id="address" 
                  v-model="localPlantData.address"
                  :state="getValidationState(validationContext)"
                  rows="3"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- Field: Longitude -->
          <b-col cols="12" md="6">
            <validation-provider 
              #default="validationContext" 
              name="Longitude"
              rules="required"
            >
              <b-form-group>
                <h5>{{ $t('plant.longitude') }}</h5>
                <b-form-input 
                  id="longitude" 
                  v-model="localPlantData.longitude" 
                  :state="getValidationState(validationContext)"
                  type="number"
                  step="any"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- Field: Latitude -->
          <b-col cols="12" md="6">
            <validation-provider 
              #default="validationContext" 
              name="Latitude"
              rules="required"
            >
              <b-form-group>
                <h5>{{ $t('plant.latitude') }}</h5>
                <b-form-input 
                  id="latitude" 
                  v-model="localPlantData.latitude" 
                  :state="getValidationState(validationContext)"
                  type="number"
                  step="any"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <!-- Action Buttons -->
        <b-button 
          variant="primary" 
          class="mb-1 mb-sm-0 mr-0 mr-sm-1"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'" 
          type="submit"
        >
          {{ $t('Save Changes') }}
        </b-button>
        <b-button 
          variant="outline-secondary" 
          type="reset" 
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          :to="{ name: 'plant-list' }"
        >
          {{ $t('Cancel') }}
        </b-button>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import store from '@/store'
import router from '@/router'
import {
  BFormInvalidFeedback, VBToggle, VBModal, BCard, BRow, BCol, BFormInput, BButton, 
  BTable, BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination, 
  BFormGroup, BFormSelect, BSidebar, BForm, BFormTextarea
} from 'bootstrap-vue'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  name: 'PlantEditTab',
  components: {
    ToastificationContent,
    VBToggle, VBModal, BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
    BFormInvalidFeedback, BBadge, BDropdown, BDropdownItem, BPagination, BFormGroup, 
    BFormSelect, BSidebar, BForm, BFormTextarea,
    ValidationProvider,
    ValidationObserver
  },
  props: {
    plantData: {
      type: Object,
      required: true,
    }
  },
  setup(props) {
    const blankPlantData = {
      name: '',
      address: '',
      longitude: '',
      latitude: ''
    }

    const localPlantData = ref(props.plantData ?? blankPlantData)
    
    const resetPlantData = () => {
      localPlantData.value = JSON.parse(JSON.stringify(blankPlantData))
    }

    const toast = useToast()
    
    const onSubmit = () => {
      store.dispatch('updatePlant', localPlantData.value)
        .then(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Success updating plant',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          router.push({ name: 'plant-list' })
        })
        .catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error updating plant',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetPlantData)

    return {
      localPlantData,
      onSubmit,
      refFormObserver,
      getValidationState,
      resetForm,
    }
  }
}
</script>

<style lang="scss">
</style>

